import React from 'react';
import { ORGANIZATION_ROLE, ORGANIZATION_ROLE_ICONS, ORGANIZATION_ROLE_NAME } from '../../organization';
import Icon from '@mdi/react';
import * as Styled from './OrganizationRoleInfo.styles';
import {Trans, useTranslation} from 'react-i18next';

interface OrganizationRoleInfoProps {
  role: ORGANIZATION_ROLE;
  marginTop?: boolean;
}

const OrganizationRoleInfo: React.FC<OrganizationRoleInfoProps> = ({ role, marginTop }) => {
  let infoPoints: string[] = [];
  const { t } = useTranslation();
  switch (role) {
    case ORGANIZATION_ROLE.MEMBER:
      infoPoints = [t('pages.orgInvite.memberForm.organizationRole.onlyView')];
      break;
    case ORGANIZATION_ROLE.MANAGER:
      infoPoints = [
        t('pages.orgInvite.memberForm.organizationRole.allFromRole', {role: ORGANIZATION_ROLE_NAME[ORGANIZATION_ROLE.MEMBER]}),
        t('pages.orgInvite.memberForm.organizationRole.allChecks')
      ];
      break;
    case ORGANIZATION_ROLE.LOCAL_ADMIN:
      infoPoints = [
        t('pages.orgInvite.memberForm.organizationRole.allFromRole', {role: ORGANIZATION_ROLE_NAME[ORGANIZATION_ROLE.MANAGER]}),
        t('pages.orgInvite.memberForm.organizationRole.canDelete'),
        t('pages.orgInvite.memberForm.organizationRole.canInvite'),
        t('pages.orgInvite.memberForm.organizationRole.canEditMembers'),
        t('pages.orgInvite.memberForm.organizationRole.organizationDashboard'),
      ];
      break;
    default:
      return null;
  }

  return (
    <div style={{ marginTop: marginTop ? '20px' : undefined }}>
      <Styled.NameContainer>
        <Icon path={ORGANIZATION_ROLE_ICONS[role]} size={0.75} />
        <span><Trans i18nKey={'pages.orgInvite.memberForm.role'}/> "{ORGANIZATION_ROLE_NAME[role]}"</span>
      </Styled.NameContainer>
      <Styled.Ul>
        {infoPoints.map((point, i) => (
          <li key={`${role}-${i}`}>{point}</li>
        ))}
      </Styled.Ul>
    </div>
  );
};

export default OrganizationRoleInfo;
